<template>
  <div>
    <app-banner title="Welcome" />
    <section class="content-wrapper">
      <div class="content">
        <h1 class="h3">Welcome to our Web Affiliate Program!</h1>
        <p class="p3">
          Here's what happens next:<br />
          You choose a graphic to be your Web Affiliate Badge. Add the graphic
          to your site where Visitors normally shop. Link the Badge from your
          site to the Balanced Body site using the customized tracking URL
          contained in your invitation email.
        </p>
        <p class="p3">
          Please <a href="mailto:mark.bauer@pilates.com">contact us</a> with any
          questions.
        </p>
        <button class="btn" @click="nextPage">Get Started</button>
      </div>
      <img
        :src="`${$assets}img-affiliate-1@1x.jpg`"
        :srcset="`${$assets}img-affiliate-1@2x.jpg 2x`"
        alt="Woman working out on a Reformer"
        class="wide photo"
      />
    </section>
  </div>
</template>

<script>
import AppBanner from "@/components/AppBanner.vue";

export default {
  name: "StepOne",

  components: {
    AppBanner
  },

  methods: {
    nextPage() {
      this.$emit("clicked", "two");
    }
  }
};
</script>

<style scoped>
.content-wrapper {
  display: flex;
}

.content {
  padding: 50px 32px;
  width: 100%;
}

.h3 {
  color: var(--dk-olive-green);
  margin-bottom: 20px;
}

.p3 {
  margin-bottom: 25px;
}

.p3 a {
  color: inherit;
  transition: 0.3s;
}

.p3 a:hover {
  color: gray;
}

.p4 {
  margin-bottom: 25px;
}

.btn {
  background-color: var(--green);
  color: var(--white);
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 14rem;
  line-height: 1.143;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 165px;
  height: 30px;
  transition: 0.3s;
}

.btn:hover {
  background-color: var(--dk-green);
}

.photo {
  width: 41%;
  max-width: 472px;
  object-fit: cover;
  flex: 0 0 auto;
  margin-left: auto;
}

@media (min-width: 768px) {
  .content {
    padding: 70px 5%;
    width: 59%;
  }

  .h3 {
    margin-bottom: 30px;
  }

  .p3 {
    font-size: 19rem;
    line-height: 1.421;
    margin-bottom: 40px;
  }
}
</style>
